import { Component, OnInit, ViewChild } from '@angular/core';
import { BaseComponent } from '../base/base.component';
import { CommonService } from 'src/app/services/common.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { HttpClickHandler } from 'src/app/directives/http-click.directive';
import { OPTIONS, SSO_SYSTEMS } from 'src/app/classes/Enums';
import { ResponsePage } from 'src/app/classes/ResponsePage';
import { MatTableDataSource } from '@angular/material/table';
import { User } from 'src/app/classes/User';
import { PageEvent } from '@angular/material/paginator';
import { MatSort, Sort } from '@angular/material/sort';
import { FilterablePageRequest } from 'src/app/classes/FilterablePageRequest';
import { UserDTO } from 'src/app/classes/UserDTO';
import { ToastType } from 'src/app/classes/ToastType';

@Component({
  selector: 'app-configuration',
  templateUrl: './configuration.component.html',
  styleUrls: ['./configuration.component.scss']
})
export class ConfigurationComponent extends BaseComponent implements OnInit {
  form: FormGroup;
  ssoSystemsEnum = Object.keys(SSO_SYSTEMS)
    .filter(key => !isNaN(Number(SSO_SYSTEMS[key]))) // Filter out non-numeric values
    .map(key => ({ text: key, value: SSO_SYSTEMS[key] }));
  formControlNames: string[];
  displayedColumns: string[] = ['id', 'username', 'count', 'isBlocked'];;
  userPage: ResponsePage;
  dataSource: MatTableDataSource<UserDTO>;
  optionEnum = OPTIONS;
  ssoSystemEnum = SSO_SYSTEMS;
  @ViewChild("dataSourceSort") dataSourceSort: MatSort;

  constructor(private commonService: CommonService, private fb: FormBuilder) {
    super();
    this.dataSource = new MatTableDataSource([]);
    this.userPage = new ResponsePage();
  }

  ngOnInit() {
    this.buildForm();
    this.getSettings();
  }
  ngAfterViewInit(): void {
    this.getUsersInitial();
  }

  saveAndUpdate(httpClickHandler?: HttpClickHandler): void {
    if (this.form.valid) {
      const formData = this.form.value;
      const commonValues = [
        { systemID: this.ssoSystemEnum.DEWAN_ADMIN, optionID: this.optionEnum.URL, optionVal: formData[this.util.getKeyByValue(this.ssoSystemEnum, this.ssoSystemEnum.DEWAN_ADMIN)] },
        { systemID: this.ssoSystemEnum.DEWAN_END_USER, optionID: this.optionEnum.URL, optionVal: formData[this.util.getKeyByValue(this.ssoSystemEnum, this.ssoSystemEnum.DEWAN_END_USER)] },
        { systemID: this.ssoSystemEnum.IMLK_MANEGER, optionID: this.optionEnum.URL, optionVal: formData[this.util.getKeyByValue(this.ssoSystemEnum, this.ssoSystemEnum.IMLK_MANEGER)] },
        { systemID: this.ssoSystemEnum.IMLK_VIEWER, optionID: this.optionEnum.URL, optionVal: formData[this.util.getKeyByValue(this.ssoSystemEnum, this.ssoSystemEnum.IMLK_VIEWER)] },
        { systemID: this.ssoSystemEnum.WORKFLOW_ADMIN, optionID: this.optionEnum.URL, optionVal: formData[this.util.getKeyByValue(this.ssoSystemEnum, this.ssoSystemEnum.WORKFLOW_ADMIN)] },
        { systemID: this.ssoSystemEnum.WORKFLOW_END_USER, optionID: this.optionEnum.URL, optionVal: formData[this.util.getKeyByValue(this.ssoSystemEnum, this.ssoSystemEnum.WORKFLOW_END_USER)] },
        { systemID: null, optionID: this.optionEnum.COUNTOFLOCK, optionVal: formData['count'].toString() }
      ];

      this.commonService.addUpdateSettings(commonValues, httpClickHandler).subscribe(data => {
        this.getSettings();
        this.getUsersInitial();
        this.util.createToast(this.translatePipe.getLabel("success"), ToastType.SUCCESS);
      });
    }
  }

  unblockUser(element: any): void {
    this.commonService.unBlock({ id: element.id }).subscribe(data => {
      this.getUsersInitial();
    });
  }

  getUsersInitial(httpClickHandler?: HttpClickHandler): void {
    let page = new PageEvent();
    page.pageIndex = 0;
    page.pageSize = this.userPage.size;
    this.getUsers(page, httpClickHandler);
  }

  getUsers(pageEvent: PageEvent, httpClickHandler?: HttpClickHandler): void {
    let wrapper = new FilterablePageRequest();
    if (pageEvent) {
      wrapper.pageNumber = pageEvent.pageIndex;
      wrapper.pageSize = pageEvent.pageSize;
    }

    wrapper.sortList = this.util.getSortFromDataSource(this.dataSourceSort);

    this.commonService.getUserPage(wrapper, httpClickHandler).subscribe(data => {
      this.dataSource.data = data.content;
      this.userPage = new ResponsePage();
      this.userPage.size = wrapper.pageSize;
      this.userPage.number = wrapper.pageNumber;
      this.userPage.content = data.content;
      this.userPage.totalElements = data.totalElements;
    });
  }

  getSettings() {
    this.commonService.getSettings({}).subscribe(data => {
      this.form.controls[this.util.getKeyByValue(this.ssoSystemEnum, this.ssoSystemEnum.DEWAN_ADMIN)].setValue(data.find(m => { return m.systemID == this.ssoSystemEnum.DEWAN_ADMIN }).optionVal);
      this.form.controls[this.util.getKeyByValue(this.ssoSystemEnum, this.ssoSystemEnum.DEWAN_END_USER)].setValue(data.find(m => { return m.systemID == this.ssoSystemEnum.DEWAN_END_USER }).optionVal);
      this.form.controls[this.util.getKeyByValue(this.ssoSystemEnum, this.ssoSystemEnum.IMLK_MANEGER)].setValue(data.find(m => { return m.systemID == this.ssoSystemEnum.IMLK_MANEGER }).optionVal);
      this.form.controls[this.util.getKeyByValue(this.ssoSystemEnum, this.ssoSystemEnum.IMLK_VIEWER)].setValue(data.find(m => { return m.systemID == this.ssoSystemEnum.IMLK_VIEWER }).optionVal);
      this.form.controls[this.util.getKeyByValue(this.ssoSystemEnum, this.ssoSystemEnum.WORKFLOW_ADMIN)].setValue(data.find(m => { return m.systemID == this.ssoSystemEnum.WORKFLOW_ADMIN }).optionVal);
      this.form.controls[this.util.getKeyByValue(this.ssoSystemEnum, this.ssoSystemEnum.WORKFLOW_END_USER)].setValue(data.find(m => { return m.systemID == this.ssoSystemEnum.WORKFLOW_END_USER }).optionVal);
      this.form.controls['count'].setValue(data.find(m => { return m.optionID == this.optionEnum.COUNTOFLOCK }).optionVal);
    });
  }

  clear() {
    this.form.reset();
  }

  private buildForm(): void {
    const formControls = {};
    Object.values(this.ssoSystemsEnum).forEach(Key => {
      formControls[Key.text] = ['', [Validators.required, Validators.minLength(10), Validators.maxLength(200)]];
    });
    formControls['count'] = ['', [Validators.required, Validators.min(1), Validators.max(10), Validators.pattern(/^[1-9]\d*$/)]];
    this.formControlNames = Object.keys(formControls).filter(controlName => controlName !== 'count');
    this.form = this.fb.group(formControls);
  }
}
